var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperioresPp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9913 7.13552C17.9913 10.6593 15.0626 13.5152 11.449 13.5152C7.83539 13.5152 4.90671 10.6593 4.90671 7.13552C4.90671 3.61175 7.83539 0.755859 11.449 0.755859C15.0626 0.755859 17.9913 3.61175 17.9913 7.13552Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2668 17.9012L13.4211 23.1243C13.4211 23.1243 11.1842 24.4664 10.7368 26.2559L2.45335 26.2745C1.0989 26.2745 0 25.2029 0 23.8821V21.8087C0 18.2152 2.90824 15.3095 6.5525 15.14L8.99563 24.6796L10.6312 17.9012L8.99563 15.1101H13.9023L12.2668 17.9012Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0933 14.7222C29.0933 18.2459 26.1646 21.1018 22.551 21.1018C18.9374 21.1018 16.0087 18.2459 16.0087 14.7222C16.0087 11.1984 18.9374 8.3425 22.551 8.3425C26.1646 8.3425 29.0933 11.1984 29.0933 14.7222Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0044 32.2662L27.4475 22.7266C31.0917 22.8961 34 25.8018 34 29.3954V31.4688C34 32.7896 32.9011 33.8611 31.5466 33.8611H13.5554C12.2009 33.8611 11.102 32.7896 11.102 31.4688V29.3954C11.102 25.8018 14.0103 22.8961 17.6545 22.7266L20.0976 32.2662L21.7332 25.4878L20.0976 22.6967H25.0044L23.3688 25.4878L25.0044 32.2662Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperioresPp);
export default __webpack_public_path__ + "static/media/SuperioresPP.f565c4a537b0fc5c2f90b4e512bfd352.svg";
export { ForwardRef as ReactComponent };